import DisplayDataServer from "../../components/admin/DisplayDataServer";
const About=()=>{
    return <DisplayDataServer name={"A Propos"} type={"about"}/>
}

export default About;